import { ComponentRef, ElementRef, EmbeddedViewRef, Injector, Pipe, PipeTransform, ViewContainerRef } from '@angular/core';
import { format } from 'currency-formatter';

import { environment as ENV } from '@environment';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { isNullOrUndefined } from '@app/util/util';

@Pipe({
  name: 'currencyFormat',
  standalone: false
})
export class CurrencyFormatPipe implements PipeTransform {

  private vcr: ViewContainerRef;
  private elementRef: ElementRef;

  private readonly ATTR_FORMATTED = 'currency-has-been-formatted';

  constructor(
    private readonly injector: Injector,
  ) { }

  transform(
    price: number, currencyCode: string, htmltag: boolean | undefined = false, displayCode: boolean | undefined = true
  ): string {
    const formatedPrice = format(this.round(price, 2), {
      code: currencyCode,
      precision: ENV.currency_precision,
      format: '%s%v'
    });
    const displaySufixCode = !!displayCode && ENV.countryInfo?.show_currency_sufix;

    if (displaySufixCode && htmltag && currencyCode) {
      this.vcr = this.injector.get(ViewContainerRef);
      this.elementRef = this.injector.get(ElementRef);
      if (!this.currencyHasBeenFormatted(this.elementRef)) {
        const component = this.vcr?.createComponent(TypographyDsComponent, { injector: this.injector });
        this.addCurrencyFormatted(currencyCode, this.elementRef, component);
      }
    }

    return displaySufixCode && !htmltag && currencyCode ? `${formatedPrice} ${currencyCode}` : formatedPrice;
  }

  private addCurrencyFormatted(
    currencyCode: string, elementRef: ElementRef, component: ComponentRef<TypographyDsComponent>
  ): void {

    component?.setInput('size', TypographyFontSize.Minor);
    component?.setInput('fontFamily', TypographyFontFamily.Regular);
    component?.setInput('text', currencyCode);
    component?.setInput('color', TypographyColor.Primary);
    component?.hostView?.detectChanges();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const domElem = (component?.hostView as EmbeddedViewRef<any>)?.rootNodes?.[0] as HTMLElement;

    if (domElem?.childNodes?.[0]?.['style']) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ((domElem.childNodes[0]) as any).style.display = 'inline-block';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ((domElem.childNodes[0]) as any).style.marginLeft = 'var(--spacing-quarck)';
    }

    if (elementRef?.nativeElement?.childNodes?.[0]?.style) {
      elementRef.nativeElement.childNodes[0].style.display = 'inline-block';
      elementRef.nativeElement.childNodes[0].style.direction = 'rtl';
      elementRef.nativeElement.childNodes[0].appendChild(domElem);
    }

    if (elementRef?.nativeElement) {
      elementRef.nativeElement.setAttribute(this.ATTR_FORMATTED, true);
    }
  }

  private currencyHasBeenFormatted(elementRef: ElementRef): boolean {
    return !isNullOrUndefined(elementRef?.nativeElement?.getAttribute?.(this.ATTR_FORMATTED));
  }

  private round(value: number, decimalQuantity: number = 0): string | number {
    if (ENV.currency_precision > 0) {
      const decimal = Math.pow(10, decimalQuantity);
      return value ? Math.round(value * decimal) / decimal : value;
    } else {
      return value ? Math.ceil(value) : value;
    }
  }
}
